import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_edit_ip",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_6 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_7 = { class: "scroll-y me-n7 pe-7" }
const _hoisted_8 = { class: "fv-row mb-5" }
const _hoisted_9 = { class: "d-flex flex-stack" }
const _hoisted_10 = { class: "me-5" }
const _hoisted_11 = { class: "fs-5 fw-bold" }
const _hoisted_12 = { class: "fs-7 fw-bold text-gray-400" }
const _hoisted_13 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_14 = { class: "modal-footer flex-center" }
const _hoisted_15 = {
  type: "reset",
  class: "btn btn-white me-3",
  "data-bs-dismiss": "modal"
}
const _hoisted_16 = { class: "indicator-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Input = _resolveComponent("Input")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loading,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          model: _ctx.ipUpdateData,
          ref: "editIpForm"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("h2", null, _toDisplayString(`${_ctx.$t("message.EDIT")} ${_ctx.$t("message.IP_ADDRESS")}`), 1),
              _hoisted_5
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_Input, {
                  type: "text",
                  name: "ip_address",
                  label: _ctx.$t('message.NAME'),
                  placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.IP_ADDRESS')}`,
                  requiredMsg: `${_ctx.$t('message.IP_ADDRESS')} ${_ctx.$t('message.IS_REQUIRED')}`,
                  ip_address: _ctx.ipUpdateData.ip_address,
                  "onUpdate:ip_address": _cache[1] || (_cache[1] = ($event: any) => (_ctx.ipUpdateData.ip_address = $event)),
                  target: "ip_address",
                  required: true,
                  value: _ctx.ipUpdateData.ip_address,
                  disabled: true
                }, null, 8, ["label", "placeholder", "requiredMsg", "ip_address", "value"])
              ]),
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("div", _hoisted_10, [
                    _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("message.STATUS")), 1),
                    _createVNode("div", _hoisted_12, _toDisplayString(`${_ctx.$t("message.SITE")} ${_ctx.$t("message.ACTIVATE_AND_DEACTIVATE")}`), 1)
                  ]),
                  _createVNode("span", _hoisted_13, [
                    _createVNode(_component_el_switch, {
                      modelValue: _ctx.ipUpdateData.status,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.ipUpdateData.status = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("button", _hoisted_15, _toDisplayString(_ctx.$t("message.CANCEL")), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-custom",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submitHandlerForm()))
              }, [
                _createVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("message.SUBMIT")), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ])
  ]))
}